import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ddt from '@wix/da-ddt';
import * as Cookie from 'js-cookie';
import { setCookieAccepted, setCookieSettings } from '../../publicSession/actions';
/**
 * Nitro ads CMP
 *
 * https://docs.nitropay.com/en/articles/4603199-adding-custom-consents-disclosures-to-the-consent-management-platform
 */ export function useCmpInit({ adsEnabled  }) {
    const NITRO_COOKIE = 'ncmp-cc';
    const dispatch = useDispatch();
    const checkConsent = (cmpKey, cookieKey)=>{
        window['__tcfapi']('hasCustomConsent', 2, (res)=>{
            if (res) {
                dispatch(setCookieSettings({
                    [cookieKey]: true
                }));
                ddt.log('ads', `CMP: ${cmpKey} opted in`);
            }
        }, cmpKey);
    };
    useEffect(()=>{
        if (!adsEnabled || typeof window === 'undefined') {
            return;
        }
        if (typeof window['__tcfapi'] === 'undefined') {
            return;
        }
        const cmpCallback = ()=>{
            ddt.log('ads', 'CMP: useractioncomplete TO', Cookie.get(NITRO_COOKIE));
            checkConsent('da-analytics', 'analytics');
            checkConsent('da-functional', 'functional');
            checkConsent('da-marketing', 'marketing');
            // save consent settings
            dispatch(setCookieAccepted());
        };
        window['__tcfapi']('addEventListener', 2, (tcData, success)=>{
            ddt.log('ads', 'CMP: useractioncomplete', tcData, Cookie.get(NITRO_COOKIE));
            if (success && tcData.eventStatus === 'useractioncomplete') {
                setTimeout(cmpCallback, 0); // Seems complete needs a delay before reading...
            }
        });
        // Also check the cookie, this might happen if user is fast and clicks the accept button
        // before react loads (as react boot is slow) so in this case we read the cookie and set
        // the cookie acceptance. Slight chance they could browse away but we need redux...
        const consentCookie = Cookie.get(NITRO_COOKIE);
        if (consentCookie && /da-analytics|da-functional|da-marketing/.test(consentCookie)) {
            const consents = consentCookie.split(',');
            dispatch(setCookieSettings({
                analytics: consents.includes('da-analytics'),
                functional: consents.includes('da-functional'),
                marketing: consents.includes('da-marketing')
            }));
            dispatch(setCookieAccepted());
        }
    // We only want this to run once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
